// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionOperators_RemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for POST /so/production_operators/remover
 *
 * Soft-deletes a production operator (sets is_active = 0). Wire shape:
 * `dados: null` — empty success acknowledgement.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ProductionOperators_RemoverResponseDados = null;

export type ProductionOperators_RemoverResponse = ApiResponse<ProductionOperators_RemoverResponseDados>;

registerResponseContract('ProductionOperators_RemoverResponse', {})
